import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@shared/services/configuration.service';

@Component({
  selector: 'app-manage-password-modal',
  templateUrl: './manage-password-modal.component.html',
  styleUrls: ['./manage-password-modal.component.scss'],
})
export class ManagePasswordModalComponent {

  readonly name: string = 'manage-password-modal';

  constructor(
    private translateService: TranslateService,
  private configurationService: ConfigurationService) {}

  onMyaccount(): void {
    window.open(this.configurationService.configuration.api.myaccount, '_blank');
  }

  get iframeSrc(): string {
    return `/account.html?lang=${this.translateService.currentLang}`;
  }
}
